import type { PropsWithChildren } from 'react';

import { cn } from '@/shared/helpers';

type DetailGroupProps = PropsWithChildren<{
  className?: string;
}>;

export function DetailGroup({ className, children }: DetailGroupProps) {
  return (
    <div
      data-slot="detail-group"
      className={cn(
        'grid min-w-0 grid-cols-[fit-content(--spacing(36))_minmax(0,1fr)] text-sm',
        className,
      )}
    >
      {children}
    </div>
  );
}
